export default __webpack_public_path__ + "static/media/avatar-s-15.bd2458dd.jpg";